<template>
    <div class="logincontain">
        <div style="background: #fff;">
            <div class="login_header display_flex  justify-content_flex-justify align-items_center">
                <div class="logo cursor_p" @click="gorouter('/')"></div>
                <!-- <img src="https://p1.fishqc.net/FrSb5jkNK6Wvm95F3da387mcTen4" width="181" height="51" class="logo cursor_p" title="好东西，就要小鱼亲测" @click="gorouter('/')" > -->
                <div class="login_header_right">{{onRoutesPath == '/login'?'登录账号':(onRoutesPath == '/reset'?'找回密码':'注册账号')}}</div>
            </div>
        </div>
        <div class="login_content">
            <div style="padding-top:90px;box-sizing:border-box;">
                <div class="login_content_box position_relative">
                    
                    <div class="display_flex  justify-content_flex-justify">
                        <div style="width:536px;height:100%;padding:84px 8px 8px;box-sizing:border-box;">
                            <swiper :options="swiperOption" ref="mySwiper">
                                <swiper-slide class="swiper-slide" v-for="(item,index) in bannerArr" :key="index">
                                    <div class="banneritem" :style="{backgroundImage:'url('+item.url+')'}"></div>
                                    <div class="login_swiper_title">{{item.title}}</div>
                                    <div class="login_swiper_desc">{{item.desc}}</div>
                                </swiper-slide>
                                <!-- 分页器 -->
                                <div class="swiper-pagination indexpage" slot="pagination"></div>
                            </swiper>
                        </div>
                        <slot></slot>
                       
                    </div>
                </div>
            </div>
            <div class="padding_top_64">
            <!-- <div class="slider-index" v-for="(item,index) in menu">
                        <router-link target="_blank" :to="{path:item.path}">{{item.name}}</router-link>
                    </div> -->
                <ul>
                    <li class="login_common_footer" v-for="(item,index) in menu"><router-link target="_blank" :to="{path:item.path}">{{item.name}}</router-link>
                    </li>
                    <!-- <li class="login_common_footer">联系小鱼</li>
                    <li class="login_common_footer">检测技术</li> -->
                    <!-- <li class="login_common_footer">F&Q</li> -->
                </ul>
            </div>
            <div class="beian">
                <span href="javascript:;" class="margin_right_16">Copyright 2016-2021 fishqc.com All rights reserved.</span>
                <a  href="//beian.miit.gov.cn/" class="color_white margin_right_16">粤ICP备18074060号</a>
                <img  src="http://p1.fishqc.net/gongan-beian.png" style="width: 18px; margin: 0px 5px 0px 10px; vertical-align: middle;">
                <a  target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402001561" class="color_white">粤公网安备 44010402001561号</a>
            </div>
        </div>
        
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.logincontain {
    height: 100%;
    background: linear-gradient(337deg, #28D877 0%, #0DC6B8 100%);
       /*opacity: 0.6029;*/
}

.login_header_right {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 32px;
}

.login_content {

    // background: linear-gradient(337deg, #28D877 0%, #0DC6B8 100%);
    // opacity: 0.6029;
}

.login_content_box {
    max-width: 940px;
    margin: 0px auto 0;
    height: 510px;
    box-sizing: border-box;
    background: #fff;
    padding-top: 30px;
    box-sizing: border-box;
}

.login_header {
    width: 940px;
    height: 100px;
    margin: 0 auto;

}

.padding_top_64 {
    padding-top: 64px;
    box-sizing: border-box;
}

.logintab {
    width: 230px;
    height: 40px;
    line-height: 40px;
    background: #CEF4E6;
    border-radius: 8px 8px 0px 0px;
    display: inline-block;
    color: #51515C;
    text-align: center;
    cursor: pointer;
    &.active {
        background: #fff;
        color: #60DEB4;
    }
}

.tab_position {
    position: absolute;
    top: -10px;
    right: 0;
}

.banneritem {
    width: 100%;
    height: 200px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;
    cursor: grabbing;

}

.login_swiper_title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 24px;
    padding-top: 30px;
    box-sizing: border-box;
}

.login_swiper_desc {
    padding-top: 8px;
    box-sizing: border-box;
    width: 336px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 24px;
    text-align: center;
    margin: 0 auto;
}

.tabtype {
    display: inline-block;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    position: relative;
    .tabText {
      cursor: pointer;
        &.active:after {
          content:'';
            position: absolute;
            left: 50%;
            bottom: -20px;
            transform: translate(-50%, -50%);
            width: 40px;
            height: 8px;
            // background: url('http://p1.fishqc.net/FjqWRRna4idwPR9ZmZkYK5D19Xxn') no-repeat;
        }
    }

    &:nth-of-type(2) {
        margin-left: 32px;
    }
}

.field {
    width: 320px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 58px;
    position: relative;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    &.margin-top {
        margin-top: 20px;
    }

    .fieldtip {
        position: absolute;
        left: 0;
        color: #333;
        bottom: 10px;
        font-size: 14px;
        line-height: 20px;
        transition: all .4s linear;

        &.animation {
            bottom: 32px;
            font-size: 12px;
            line-height: 16px;

        }
    }

    .fielderror {
        position: absolute;
        right: 0;
        color: #ff3366;
        bottom: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    .fieldcodeerror {
        position: absolute;
        right: 31%;
        color: #ff3366;
        bottom: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    .fieldinput {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border: none;
        font-size: 14px;
        height: 24px;
        line-height: 32px;
        color: #333;
        border-bottom: 2px solid #F8FBFD;

        &.codebox {
            width: 70%;
        }

        &.error {
            border-bottom: 2px solid #ff3366;
        }
    }

    .codedetail {
        width: 30%;
        display: inline-block;
        position: absolute;
        right: 0;
        bottom: 0;
        height: 100%;
        cursor: pointer;
    }

    .left_field{
        position:absolute;
        width:66%;
        height:100%;
        vertical-align: middle;
        left:0;
    }

    .right_field{
        position:absolute;
        bottom: 10px;
        right: 0;
        width:30%;
        vertical-align: middle;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
        &:before{
            content:'';
            position: absolute;
            width: 1px;
            height: 20px;
            left:4px;
            background-color: #999;
        }
    }
}

.loginbtn {
    width: 320px;
    height: 48px;
    background: #60DEB4;
    margin: 24px auto 16px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}

.width_320 {
    width: 320px;
    margin: 0 auto;
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #2F3736;
}

.otherlogin{
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #848A95;
    line-height: 17px;
    margin:32px 0 18px;
    box-sizing: border-box;
    position: relative;
    &:before{
        content:'';
        position:absolute;
        width: 80px;
        height: 1px;
        background-color: #DDDDDD;
        left:0;
        top:50%;
        transform: translate(0,-50%);
    }
    &:after{
        content:'';
        position:absolute;
        width: 80px;
        height: 1px;
        background-color: #DDDDDD;
        right:0;
        top:50%;
        transform: translate(0,-50%);
    }
}

.facebookbtn{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    background: #1877F2;
}

.margin_right_10{
    margin-right: 10px;
}


.login_common_footer{
    display: inline-block;
    padding:0 16px;
    box-sizing: border-box;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    a{
        color: #FFFFFF;
    }
}

.beian{
    
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        padding:24px 0px 0;
        box-sizing: border-box;
        display: inline-block;
    a{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
    }

    .margin_right_16{
        margin-right: 16px;
        

    }
    
}

.logo{
    width: 186px;
    height: 52.7px;
    background-image:url('https://p1.fishqc.net/FrSb5jkNK6Wvm95F3da387mcTen4');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
   /* margin-right: 32px;*/
    cursor: pointer;
}
</style>
<style type="text/css" lang="scss">
.login_content {

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
        bottom: 98px;
        left: 0;
        width: 100%;
    }
}
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'

export default {
    name: 'login',
    props: {
        list: Array
    },
    components: {
    },
    mixins: [myMixin],
    data() {
        return {
            bannerArr: [{
                    url: 'http://p1.fishqc.net/FuYS_k0hvUQhuUrc70_yWvIWpxPs',
                    title: '消费品样本',
                    desc: '应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质'

                },
                {
                    url: 'http://p1.fishqc.net/FjTKq8isGu_mQ5_7K36d_Q_UoPNd',
                    title: '安全及功效测试',
                    desc: '应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质'

                },
                {
                    url: 'http://p1.fishqc.net/FlIYe8nCMT2GUXZln_V90ozusVI3',
                    title: '输出安全性及功效报告',
                    desc: '应用2008年诺贝尔奖荧光标记技术，24小时快速筛查类雌性激素慢性毒物质'

                }
            ],
            swiperOption: {
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                //自动轮播
                autoplay: {
                    delay: 3000,
                    //当用户滑动图片后继续自动轮播
                    disableOnInteraction: false,
                },
                //开启循环模式
                loop: true,

            },
            menu: [{
                    name: this.$t('common.footer.about'),
                    path: '/about?position=aboutfishqc'
                },
                {
                    name: this.$t('common.footer.contact'),
                    path: '/about?position=contact'
                },
                {
                    name: this.$t('common.footer.technology'),
                    path: '/about?position=technology'
                },
                // {
                //     name: 'F&Q',
                //     path: ''
                // }
            ],
        }
    },
    methods: {
       
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    mounted() {

        // console.log('Current Swiper instance object', this.swiper)
        this.swiper.slideTo(0, 2000, false)
    }
}
</script>